import React, { createContext, useCallback, useContext } from "react";
import { BASE_URL_ADMIN, BASE_URL_HR, BASE_URL_AUDIT } from "../api/useAxios";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useAuth } from "./auth";


function DataSourceProvider(props) {
    const { user, setUser, activeLanguage } = useAuth()

    const createDataSource = useCallback((props) => {
        const {
            key,
            baseUrl,
            loadUrl,
            insertUrl,
            updateUrl,
            deleteUrl,
            parentId,
            onLoaded,
            onLoading,
            loadMode = "raw" } = props;

        const createUrl = (url, _parentId) => {
            if (!url)
                return undefined
            _parentId = _parentId == null ? "" : "/" + _parentId
            return `${baseUrl}${url}${_parentId}`
        };

        if (!baseUrl)
            throw new Error('dataSource nesnesi için bir "baseUrl" belirtilmelidir.')

        if (!loadUrl)
            throw new Error('dataSource nesnesi için bir "loadUrl" belirtilmelidir.')

        const options = {}

        options.key = key ?? "id"

        options.loadUrl = createUrl(loadUrl, parentId)
        options.insertUrl = createUrl(insertUrl ?? loadUrl)
        options.updateUrl = createUrl((updateUrl ?? insertUrl) ?? loadUrl)
        options.deleteUrl = createUrl((deleteUrl ?? insertUrl) ?? loadUrl)
        options.loadMode = loadMode
        options.onLoaded = onLoaded
        options.onLoading = onLoading


        options.errorHandler = (e) => {
            const jsonString = e.toString().replace(/^.*?({.*}).*?$/, '$1');
            if (jsonString) {
                try {
                    const errObject = JSON.parse(jsonString)
                    if (errObject?.error?.statusCode == 401) {
                        setUser(undefined)
                    }
                } catch (error) {
                    //
                }
            }
        }

        options.onBeforeSend = (method, ajaxOptions) => {

            ajaxOptions.headers = {
                ...ajaxOptions.headers,
                Authorization: `Bearer ${user.token}`,
                "Accept-Language": activeLanguage ?? "tr-TR",
            }


        }

        return createStore(options)

    }, [user])

    const dataSourceAdmin = (props) => {
        props.baseUrl = BASE_URL_ADMIN
        return createDataSource(props)
    }
    const dataSourceHR = (props) => {
        props.baseUrl = BASE_URL_HR
        return createDataSource(props)
    }

    return (
        <DataSourceContext.Provider value={{ dataSourceAdmin, dataSourceHR }} {...props} />
    )
}

const DataSourceContext = createContext();
const useDataSource = () => useContext(DataSourceContext);

export { useDataSource, DataSourceProvider }